import type { ReactNode } from 'react';
import Select, { SelectChangeEvent, SelectProps } from '@mui/material/Select';

interface FilterProps<T = unknown> extends SelectProps {
  items: T[];
  value: string | number;
  // eslint-disable-next-line no-unused-vars
  onChange: (event: SelectChangeEvent<any>, child: ReactNode) => void;
  // eslint-disable-next-line no-unused-vars
  renderItem: (item: T, index: number, arr: T[]) => ReactNode;
}

const Filter = <T extends unknown>({
  items,
  value,
  onChange,
  renderItem,
  ...props
}: FilterProps<T>) => (
  <Select
    value={value}
    onChange={onChange}
    sx={{
      bgcolor: 'common.white',
      width: 1,
      boxShadow: 1,
      borderRadius: '0.25rem',
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none !important',
      },
    }}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {items.map(renderItem)}
  </Select>
);

export default Filter;
